export let notificationsArr = []

export const notification_notify = (title_blc, text_blc, component_o, timeout_n) =>{

    let obj = {
        title: title_blc,
        text: text_blc,
        component : component_o

    }

    notificationsArr.push(obj)

    setTimeout(() => {

        let index = notificationsArr.indexOf(obj)
        if(index > -1){
            notificationsArr.splice(index, 1)
        }

    }, timeout_n ? timeout_n : 2000);

}


export const notification_notify2 = ({title_s, text_s, component_o, timeout_n = 2000}) =>{

    let obj = {
        title       : title_s,
        text        : text_s,
        component   : component_o
    }

    notificationsArr.push(obj)

    setTimeout(() => {

        let index = notificationsArr.indexOf(obj)
        if(index > -1){
            notificationsArr.splice(index, 1)
        }

    }, timeout_n);

}